import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import "../styles/form.css";
import "../styles/update.css";
import { UserDetailResponse } from "../types/AuthTypes";
import { getUserById, updateUser } from "../services/authService";

const roles = ["User", "Admin", "SuperAdmin"];

const UserDetail = () => {
  const { id } = useParams<{ id: string }>();
  const userId = Number(id!);
  const [user, setUser] = useState<UserDetailResponse>({
    id: 0,
    firstName: "",
    lastName: "",
    password: "",
    email: "",
    role: ""
  });

  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await getUserById(id!);
        if (res === null)
        {
          throw ": User does not exist";
        }

        setUser({
            id: res.id,
            firstName: res.firstName,
            lastName: res.lastName,
            password: res.password,
            email: res.email,
            role: res.role
        });
      } catch (error) {
        console.error("Failed to load user", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchUser();
  }, [id]);


  
  const handleUserChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setUser({...user, [e.target.name]: e.target.value})
  };

  const handleUserSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!user!.firstName || !user!.lastName || !user!.password || !user!.email || !user!.role) {
      alert("Please fill in all required fields.");
      return;
    }

    const response = await updateUser(user);
    if (response) {
      setUser({
        id: 0,
        firstName: "",
        lastName: "",
        password: "",
        email: "",
        role: ""
      });
      alert("User updated successfully!");
      navigate("/register");
    } else {
      alert("Failed to update user");
    }
  };

  if (loading) return <p>Loading...</p>;
  if (!user) return <p>User not found.</p>;
  if (id === undefined) {
    return <p>User not found.</p>;
  }
  return (
    <div className="form-container update-form-container">
        <h2 className="text-xl font-bold mb-4">Edit User</h2>
          <form onSubmit={handleUserSubmit}>
            <div>
                <div className="input-group">
                    <div className="input-row">
                        <input type="text" name="firstName" placeholder="First Name" value={user.firstName} onChange={(e) => handleUserChange(e)} required />
                        <input type="text" name="lastName" placeholder="Last Name" value={user.lastName} onChange={(e) => handleUserChange(e)} required />
                        <input type="text" name="email" placeholder="Email" value={user.email} onChange={(e) => handleUserChange(e)} required />
                        <input type="password" name="password" placeholder="Password" value={user.password} onChange={(e) => handleUserChange(e)} required />
                        <select
                            name="role"
                            value={user.role}
                            onChange={handleUserChange}
                            >
                            <option value={0}>Please select User role</option>
                            {roles.map((r) => (
                                <option key={r} value={r}>
                                {r}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
    
            <button className="submit-button" type="submit">Submit</button>
          </form>

    </div>
  );
};

export default UserDetail;
